'use client';
import { useFeed } from "@/hooks/use-feed";
import { cn } from "@/lib/utils";
import { Inbox } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect, useRef } from "react";
import EmptyState from "../empty-state";
import Loader from "../loader";
import { Separator } from "../ui/separator";
import FeedPost from "./feed-post";
import FilterTabs from "./filter-tabs";
interface FeedListProps {
      className?: string;
      openInNewTab?: boolean;
      baseUrl?: string;
}

const FeedList = ({ className, openInNewTab = false, baseUrl = '/news' }: FeedListProps) => {
      const t = useTranslations('newsfeed');
      const { posts, loading, loadMore, project } = useFeed();

      const observerTarget = useRef<HTMLDivElement>(null);

      useEffect(() => {
            const observer = new IntersectionObserver(
                  entries => {
                        if (entries[0].isIntersecting) {
                              loadMore();
                        }
                  },
                  { threshold: 0.1 }
            );

            if (observerTarget.current) {
                  observer.observe(observerTarget.current);
            }

            return () => observer.disconnect();
      }, []);

      const noPosts = posts.length === 0 && !loading;

      return (
            <>
                  <div className={cn(" w-full space-y-2 min-h-60 max-w-4xl mx-auto", className)}>
                        <div className="flex gap-4 py-4 border-b items-center justify-between border-gray-200 px-2">
                              <h4 className="text-base lg:text-2xl font-bold">{t('lastest_news')}</h4>
                              <FilterTabs />
                        </div>

                        {noPosts ? <EmptyState title={t('no_posts_found')} description={t('no_posts_found')} icon={Inbox} /> : (
                              posts.map((post) => (<div key={post.id}>
                                    <FeedPost post={post} openInNewTab={openInNewTab} baseUrl={baseUrl} />
                                    <Separator />
                              </div>
                              ))
                        )}
                  </div>

                  <div
                        ref={observerTarget}
                        className="h-10 w-full flex items-center justify-center"
                  >
                        {loading && <Loader />}
                  </div>
            </>
      )
}

export default FeedList;
